import React from "react";
import styles from "./controls.module.css";
import FlowList from "./FlowList";
import NewFlow from "./NewFlow";
import Publish from "./Publish";
import RemoveFlow from "./RemoveFlow";
import Save from "./Save";
import Simulate from "./Simulate";
import Duplicate from "./Duplicate";
import FlowStatus from "./FlowStatus";
import WebAppPreview from "./WebAppPreview";

const Controls = ({ rfInstance, app }) => {
  return (
    <div className={styles.controls_container}>
      <NewFlow />

      <FlowList />

      <Duplicate />

      <Save />

      <RemoveFlow />

      <Publish />

      <Simulate />

      <WebAppPreview />

      <FlowStatus />
    </div>
  );
};

export default Controls;
